<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 基础设置 > 规则设置
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line" label="对应结果" style="margin-left: 10px;">
								<el-select v-model="searchData.result" placeholder="请选择">
									<el-option value="">请选择</el-option>
									<el-option v-for="item in resultOptions" :key="item.id" :label="item.result"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line" label="规则名称" style="margin-left: 10px;">
								<el-input v-model="searchData.name"></el-input>
							</el-form-item>
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="addBtn" @click="add">新增</el-button>
								<el-button size="large"  class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="80">
							</el-table-column>
							<el-table-column width="180" align="center" label="规则名" prop="name">
							</el-table-column>
							<el-table-column align="center" label="规则参数" prop="explainList">
								<template #default="{row}">
									<span v-for="(item,index) in row.explainList" :key="index">
										{{ item.type }}-{{item.value}}
										<span style="margin-left: 10px;" v-if="index < row.explainList.length-1">+</span>
									</span>
									
								</template>
							</el-table-column>
							<el-table-column align="center" label="报告结果" prop="result">
								
								<template #default="{row}">
									<div  v-if="row.result">
										{{ row.result.result ? row.result.result : "暂无" }}
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="操作" width="100">
								<template #default="{row}">
									<span class="editor" @click="edit(row)">
										编辑
									</span>
									<span class="del" @click="del(row)">
										删除
									</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" layout="prev, pager, next, jumper"
										:total="total" :page-size="10"></el-pagination>
								</div>
								<div class="data">
									共
									<span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增规则设置' : '编辑规则设置'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item label="规则设置" prop="name">
									<el-input class="longInput" v-model="addUserForm.name"></el-input>
								</el-form-item>

								<div class="dosageType">
									<el-form-item label="规则参数" prop="ruleParameters">
										<div style="margin-bottom: 10px;" class="dosage-con" v-for="(item, index) in addUserForm.ruleParameters"
											:key="index">
											<div class="do-line" style="margin-bottom: 10px;">

												<el-select style="float:left;" @change="changeTongueType(item,index)" v-model="item.type" placeholder="请选择">
													<el-option v-for="ite in tongueTypeOptions" :key="ite.value"
														:label="ite.label" :value="ite.value">
													</el-option>
												</el-select>
												<el-select style="margin-left: 20px;float:left" v-model="item.id"
													placeholder="请选择">
													<el-option v-for="ite in item.tongueOptions" :key="ite.id"
														:label="ite.value" :value="ite.id">
													</el-option>
												</el-select>

												<i style="width:20px;float: left;margin-top: 8px;" @click="addPillData()" class="dosageIcon el-icon-circle-plus">
													<CirclePlus></CirclePlus>
												</i>
												<i style="width:20px;float: left;margin-top: 8px;" @click="deletePillData(index)" class="dosageIcon el-icon-remove"
													:style="
													  addUserForm.ruleParameters.length == 1 ? 'color:#ccc;' : ''
													">
													<Remove></Remove>
												</i>
											</div>
										</div>
									</el-form-item>
								</div>
								<el-form-item class="el-form-item-line" label="报告结果" prop="result">
									<el-select v-model="addUserForm.result" placeholder="请选择">
										<el-option v-for="item in resultOptions" :key="item.id" :label="item.result"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>

								<div class="dosageType">
									<el-form-item label="子规则" prop="superiorRules">
										<div class="dosage-con" v-for="(item, index) in addUserForm.superiorRules"
											:key="index">
											<div class="do-line" style="margin-bottom: 10px;">

												<el-select v-model="item.id" placeholder="请选择">
													<el-option v-for="ite in smallOptions" :key="ite.id"
														:label="ite.name" :value="ite.id">
													</el-option>
												</el-select>


												<i @click="addSuperiorData()"
													class="dosageIcon el-icon-circle-plus"></i>
												<i @click="deleteSuperiorData(index)" class="dosageIcon el-icon-remove"
													:style="
													  addUserForm.superiorRules.length == 1 ? 'color:#ccc;' : ''
													"></i>
											</div>
										</div>
									</el-form-item>
								</div>

								<el-form-item style="display: none;" label="图片" prop="pic">
									<el-autocomplete popper-class="my-autocomplete" v-model="addUserForm.pic"
										:fetch-suggestions="querySearch" placeholder="请输入内容" @select="handleSelect">
										<template #prefix>
										    <el-icon class="el-input__icon"><Search></Search></el-icon>
										</template>
										<template #default="{item}">
											<div class="img">
												<img :src="globalImageUrl + item.path" />
												<span class="name">{{ item.name }}</span>
											</div>
										</template>
									</el-autocomplete>
									<span class="more" style="margin-left: 10px;color: #999;">最多可选3张</span>
								</el-form-item>
								<div class="select" v-if="selectedPicList.length > 0">
									<ul class="select-ul">
										<li v-for="(item, index) in selectedPicList" :key="index">
											<div class="path">
												<img :src="globalImageUrl + item.path" />
											</div>
											<span class="name">{{ item.name }}</span>
										</li>
									</ul>
									<ul class="selected-ul">
										<span class="span">已选择的图片：</span>
										<div class="li">
											<li v-for="(item, index) in selectedPicList" :key="index">
												<span class="name">{{ item.name }}</span>
												<i @click="handleClose(item)" class="el-icon-circle-close"></i>
											</li>
										</div>
									</ul>
								</div>
							</div>
						</div>
					</el-form>
				</div>
				
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import globle from "../../globle/globle";
	export default {
		data() {
			return {
				total: 0,
				currentPage: 0,
				pages: 1,
				role: "",
				tabList: [{
						id: 0,
						name: "舌面释义",
					},
					{
						id: 1,
						name: "报告结果",
					},
					{
						id: 2,
						name: "规则设置",
					},
					{
						id: 3,
						name: "养生方案",
					},
					{
						id: 4,
						name: "版本管理",
					},

				],
				currentTabIndex: 2,
				searchData: {
					name: "", 
					result: "",
				},
				resultOptions: [],			
				tongueTypeOptions: [{
						value: '舌色',
						label: '舌色'
					},
					{
						value: '舌形',
						label: '舌形'
					},
					{
						value: '苔色',
						label: '苔色'
					},
					{
						value: '苔质',
						label: '苔质'
					}
				],
				tongueOptions:[],
				tongueNameOptions: [],
				tongueColorOptions:[],					
				mossColorOptions:[],													
				coateNatureOptions:[],				
				smallOptions: [],
				tableListData: [],
				addUserForm: {
					name: "",
					pic: "", //图片
					id: "",
					createTime: "",
					ruleParameters: [{
						type: '舌色',
						id: '',
						tongueOptions:[]
					}],
					result: "",
					superiorRules: [{
						id: ''
					}]
				},
				rules: {
					name: [{
						required: true,
						message: "请输入名称",
						trigger: "blur",
					}, ],
					result: [{
						required: true,
						message: "请选择报告结果",
						trigger: "blur",
					}, ],

					

				},
				addOrEdit: "",
				addUserFlag: false,
				globalImageUrl: globle.imgPath,
				picList: [],
				selectedPicList: [], //被选中的图片
			};
		},

		methods: {
			//路由切换
			goOther(index, id) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/basicSetting/tongueInterpretation",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/basicSetting/reportResult",
					});
				}
				if (index == 2) {
					this.$router.push({
						path: "/basicSetting/ruleSetting",
					});
				}
				if (index == 3) {
					this.$router.push({
						path: "/basicSetting/healthPlan",
					});
				}
				if (index == 4) {
					this.$router.push({
						path: "/basicSetting/versionManagement",
					});
				}

			},
			//重置
			reset(){
				this.searchData.result = '';
				this.searchData.name = '';	
				this.searchPluse();
			},
			//切换舌
			changeTongueType(val,index){
				this.addUserForm.ruleParameters[index].id = ''				
				if(val.type == '舌色'){
					this.addUserForm.ruleParameters[index].tongueOptions = this.tongueColorOptions;
				}
				if(val.type == '舌形'){
					this.addUserForm.ruleParameters[index].tongueOptions = this.tongueNameOptions;
				}
				if(val.type == '苔色'){
					this.addUserForm.ruleParameters[index].tongueOptions = this.mossColorOptions;
				}
				if(val.type == '苔质'){
					this.addUserForm.ruleParameters[index].tongueOptions = this.coateNatureOptions;
				} 
			},
			//新增脉象
			add() {
				this.addUserFlag = true;
				this.addUserForm.name = "";
				this.addUserForm.body = "";
				this.addUserForm.mental = "";
				this.addUserForm.performance = "";
				this.addUserForm.pic = "";
				this.addUserForm.tend = "";
				this.addUserForm.id = "";
				this.addUserForm.createTime = "";
				this.selectedPicList = [];
				this.addOrEdit = "add";
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},
			//获取子规则数据
			getSmallData(){
				this.$applicationJson("/business/baseTongueRule/paging", {
						current:0,
						orderBy: "",
						params: {
							name: this.searchData.name,
							resultId: this.searchData.result,
						},
						size: 100
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.smallOptions = res.data.data.records;																					
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑脉象
			edit(item) {
				this.addOrEdit = "edit";
				this.getDetail(item.id);
			},
			//获取详情
			getDetail(id) {
				this.$applicationJson("/business/baseTongueRule/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserForm.name =  item.name;
							this.addUserForm.id =  item.id;
							this.addUserForm.result = item.result.id;
							if(item.explainList.length == 0){
								this.ruleParameters = [{
									type: '舌色',
									id: '',
									tongueOptions:[]
								}]
							}else{
								this.addUserForm.ruleParameters =  item.explainList;
								for(let i = 0;i<item.explainList.length;i++){
									if(item.explainList[i].type == '舌色'){
										this.addUserForm.ruleParameters[i].tongueOptions = this.tongueColorOptions;
									}
									if(item.explainList[i].type == '舌形'){
										this.addUserForm.ruleParameters[i].tongueOptions = this.tongueNameOptions;
									}
									if(item.explainList[i].type == '苔色'){
										this.addUserForm.ruleParameters[i].tongueOptions = this.mossColorOptions;
									}
									if(item.explainList[i].type == '苔质'){
										this.addUserForm.ruleParameters[i].tongueOptions = this.coateNatureOptions;
									} 
								} 
							}
							if(item.childRuleList.length == 0){
								this.addUserForm.superiorRules = [{
									id: ''
								}]
							}else{
								this.addUserForm.superiorRules = item.childRuleList;
							}
							this.addUserFlag = true;
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
							
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//删除脉象
			del(item) {
				this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						this.delConstitute(item.id);
					})
					.catch(() => {});
			},
			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},
			//确定
			addPatient(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addOrEdit == "add") {
							this.addConstitute();
						}
						if (this.addOrEdit == "edit") {
							this.editConstitute();
						}
						this.currentPage = 0;
					} else {
						return false;
					}
				});
			},
			//新增体质
			addConstitute() {
				this.$applicationJson("/business/baseTongueRule/add", {
						name: this.addUserForm.name, //规则名称
						resultId: this.addUserForm.result, //报告id
						explainList: this.addUserForm.ruleParameters,
						childRuleList: this.addUserForm.superiorRules,
						id: "",
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getPlanList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//编辑体质
			editConstitute() {
				this.$applicationJson("/business/baseTongueRule/edit", {
						name: this.addUserForm.name, //规则名称
						resultId: this.addUserForm.result, //报告id
						explainList: this.addUserForm.ruleParameters,
						childRuleList: this.addUserForm.superiorRules,
						id: this.addUserForm.id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getPlanList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除
			delConstitute(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/baseTongueRule/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.getPlanList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getPlanList(this.currentPage);
			},
			//搜索
			searchPluse() {
				this.getPlanList(0);
			},
			//获取体质维护
			getPlanList(currentPage) {
				this.$applicationJson("/business/baseTongueRule/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
							resultId: this.searchData.result,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取图片列表
			getImageList(currentPage) {
				this.$applicationJson("/business/base/image/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: "",
						},
						size: 1000
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.picList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			querySearch(queryString, cb) {
				var picList = this.picList;
				var results = queryString ?
					picList.filter(this.createFilter(queryString)) :
					picList;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			//图片搜索
			createFilter(queryString) {
				return (picList) => {
					return (
						picList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
					);
				};
			},
			//图片选择
			handleSelect(item) {
				this.selectedPicList.push(item);
				if (this.selectedPicList.length == 2) {
					return false;
				}
			},
			//图片关闭
			handleClose(tag) {
				this.selectedPicList.splice(this.selectedPicList.indexOf(tag), 1);
			},
			
			//新常见症状数据
			addPillData() {
				if (this.addUserForm.ruleParameters == undefined) {
					this.addUserForm.ruleParameters = [];
				}
				let obj = {
					type: '舌色',
					id: '',
					tongueOptions:this.tongueColorOptions
				};
				this.addUserForm.ruleParameters.push(obj);
			},
			//删除丸数据
			deletePillData(index) {
				if (this.addUserForm.ruleParameters.length > 1) {
					this.addUserForm.ruleParameters.splice(index, 1);
				}
			},
			//新常见症状数据
			addSuperiorData() {
				if (this.addUserForm.superiorRules == undefined) {
					this.addUserForm.superiorRules = [];
				}
				let obj = {
					id: ""
				};
				this.addUserForm.superiorRules.push(obj);
			},
			//删除丸数据
			deleteSuperiorData(index) {
				if (this.addUserForm.superiorRules.length > 1) {
					this.addUserForm.superiorRules.splice(index, 1);
				}
			},
			//获取报告结果
			getResultOptions(currentPage) {
				this.$applicationJson("/business/baseReportResult/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name:'',
						},
						size: 100,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.resultOptions = res.data.data.records;					
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取舌面释义
			getBaseExplainList(){
				this.$applicationJson("/business/baseExplain/paging", {
						current:0,
						orderBy: "",
						params: {
							
						},
						size: 100,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let records  = res.data.data.records;
							for(let i = 0;i<records.length;i++){
								if(records[i].type == '舌色'){
									this.tongueColorOptions.push(records[i]);
								}
								if(records[i].type == '舌形'){
									this.tongueNameOptions.push(records[i]);
								}
								if(records[i].type == '苔色'){
									this.mossColorOptions.push(records[i]);
								}
								if(records[i].type == '苔质'){
									this.coateNatureOptions.push(records[i]);
								}
							}
							this.addUserForm.ruleParameters[0].tongueOptions = this.tongueColorOptions;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			}
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(0, 5);
				}
				this.getBaseExplainList(0);
				this.getSmallData(0);
				this.getPlanList(0);
				this.getResultOptions(0)
			});
		},
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					min-height: calc(100% - 80px);

					.search-con {
						height: 60px;
					}
				}
			}

			.about {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}

			.demo-form-inline {
				margin-top: 10px;
				:deep(.el-input__inner){
					width: 160px;
				}
			}

			.editor {
				cursor: pointer;
				color: #679ff6;
			}

			.del {
				color: #df6d78;
				cursor: pointer;
				margin-left: 10px;
			}

			.search-con {
				@media screen and (min-width: 0px) and (max-width: 1060px) {
					height: 180px;
					width: 100%;
				}

				@media screen and (min-width: 1060px) and (max-width: 1280px) {
					height: 130px;
					width: 100%;
				}

				@media (min-width: 1280px) {
					width: 100%;
					height: 130px;
				}

				@media (min-width: 1480px) {
					width: 100%;
					height: 70px;
				}

				@media screen and (min-width: 1480px) and (max-width: 1856px) {
					height: 130px;
					width: 100%;
				}

				@media (min-width: 1920px) {
					width: 100%;
					height: 70px;
				}
			}
		}
	}

	.dialog {
		:deep(.el-dialog__body){
			padding: 0;

			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				height: 300px;

				.item {
					.line {
						width: 100%;
						overflow: hidden;

						&:nth-child(1) {
							margin-bottom: 20px;
						}

						.el-form-item {
							width: 100%;
						}

						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}

						.dialog-tit {
							height: 40px;
							line-height: 40px;

							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}

							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}

				.longInput {
					width: 100%;

					:deep(.el-input__inner){
						width: 100%;
					}
				}

				.smallInput {
					width: 150px;

					:deep(.el-input__inner){
						width: 100%;
					}
				}
			}
		}
	}

	.img {
		margin-bottom: 10px;
		float: left;

		img {
			float: left;
			width: 40px;
		}

		span {
			float: left;
			margin-left: 10px;
			width: calc(100% - 50px);
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
	}

	.select {
		margin-left: 40px;
		width: calc(100% - 40px);

		ul {
			float: left;
			width: 100%;
			margin-bottom: 20px;

			li {
				float: left;
				width: 120px;
				text-align: center;

				.path {
					img {
						width: 40px;
						margin-left: 40px;
						max-height: 40px;
					}

					width: 40px;
					height: 40px;
				}

				span {
					margin-left: 10px;
					width: calc(100% - 50px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					display: inline-block;
				}
			}
		}

		.selected-ul {
			float: left;
			width: 100%;
			margin-left: 40px;

			.span {
				float: left;
				width: 100px;
				line-height: 30px;
			}

			.li {
				float: left;
				width: calc(100% - 110px);

				li {
					border: 1px solid #eee;
					line-height: 30px;
					margin-right: 10px;
					width: auto;
					padding: 0 10px;

					span {
						width: 80px;
						float: left;
						line-height: 30px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}

					i {
						cursor: pointer;
						margin-left: 8px;
						color: #333;
						float: left;
						line-height: 30px;
					}
				}
			}
		}
	}
</style>
